var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('eden-page-header',{attrs:{"title":'Customers',"subtitle":_vm.name || '-',"section":'Edit Profile'}}),_c('customer-corporate-form',{attrs:{"action":'edit',"company":_vm.company}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }